import {Command} from 'src/app/domain/command/command.command';
import {uuid} from 'src/app/domain/function/uuid.helper';

export interface Login extends Command {
  username: string;
  password: string;
  recaptchaToken: string;
}

export interface LoginWithAuthCode extends Command {
  code: string;
  recaptchaToken: string;
}

export interface Register extends Command {
  email: string;
  firstName: string;
  surname: string;
  invitation: string | null;
  marketingContact: boolean;
  termsAccepted: boolean;
  recaptchaToken: string;
  plainPassword: string;
  confirmPassword: string | null;
}

export const emptyLogin = (): Login => ({
  commandId: uuid(),
  username: '',
  password: '',
  recaptchaToken: '',
});

export const createLoginWithAuthCode = (code: string): LoginWithAuthCode => ({
  commandId: uuid(),
  code,
  recaptchaToken: '',
});

export const emptyRegister = (): Register => ({
  commandId: uuid(),
  email: '',
  firstName: '',
  surname: '',
  invitation: null,
  marketingContact: false,
  termsAccepted: false,
  recaptchaToken: '',
  plainPassword: '',
  confirmPassword: '',
});

export interface Recover extends Command {
  email: string;
}

export const emptyRecover = (): Recover => ({
  commandId: uuid(),
  email: '',
});

